import { useEffect, useState } from "react";
import { listMidpointMediaCustomerProjects } from "../../api/partnerPortalApi";
import {
  badgeClass,
  formatStatusLabel,
} from "./midpointMediaCustomerPortalLabels";
import "../../styles/midpointMediaCustomerPortal.css";

export default function MidpointMediaCustomerProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [totals, setTotals] = useState(null);
  const [live, setLive] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    listMidpointMediaCustomerProjects()
      .then((body) => {
        if (cancelled) return;
        setProjects(body.projects || []);
        setTotals(body.totals || null);
        setLive(Boolean(body.live));
      })
      .catch((error) => {
        if (!cancelled) {
          setErrorMessage(error.message || "Unable to load projects.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="mm-customer-portal">
      <header className="mm-customer-portal__hero">
        <div>
          <p className="mm-customer-portal__eyebrow">Delivery</p>
          <h1>Projects</h1>
          <p className="mm-customer-portal__intro">
            Delivery status from Midpoint Media’s project workspace, including
            open and closed work packages.
          </p>
        </div>
      </header>

      {loading ? <p className="mm-customer-muted">Loading projects…</p> : null}
      {errorMessage ? <p className="mm-customer-error">{errorMessage}</p> : null}

      {!loading && !errorMessage ? (
        <>
          <section className="mm-customer-kpi-grid" aria-label="Project totals">
            <article className="mm-customer-kpi">
              <span>Projects</span>
              <strong>{totals?.projects ?? projects.length}</strong>
            </article>
            <article className="mm-customer-kpi">
              <span>Open work packages</span>
              <strong>{totals?.openWorkPackages ?? "—"}</strong>
            </article>
            <article className="mm-customer-kpi">
              <span>Source</span>
              <strong>{live ? "Live" : "Demo"}</strong>
            </article>
          </section>

          <section className="mm-customer-panel">
            <h3>Active work</h3>
            {!live ? (
              <p className="mm-customer-muted">
                Showing representative project status until OpenProject is
                connected for this workspace.
              </p>
            ) : null}
            {projects.length === 0 ? (
              <p className="mm-customer-empty">No projects to show yet.</p>
            ) : (
              <div className="mm-customer-list">
                {projects.map((project) => (
                  <article key={project.id} className="mm-customer-row">
                    <div className="mm-customer-row__top">
                      <strong>{project.name}</strong>
                      <span className={badgeClass(project.status)}>
                        {formatStatusLabel(project.status)}
                      </span>
                    </div>
                    <p>
                      {project.openWorkPackages != null
                        ? `${project.openWorkPackages} open`
                        : "Open count n/a"}
                      {project.closedWorkPackages != null
                        ? ` · ${project.closedWorkPackages} closed`
                        : ""}
                    </p>
                    {project.summary ? <p>{project.summary}</p> : null}
                    <p>{project.nextMilestone || "—"}</p>
                    <div
                      className="mm-customer-progress"
                      aria-label={`${project.progressPct || 0}% complete`}
                    >
                      <span
                        style={{
                          width: `${Math.max(0, Math.min(100, project.progressPct || 0))}%`,
                        }}
                      />
                    </div>
                  </article>
                ))}
              </div>
            )}
          </section>
        </>
      ) : null}
    </div>
  );
}
